import React, { useState, useEffect } from 'react';
import { querySupabase } from '../services/supabaseClient';
import * as supabaseKGService from '../services/supabase/knowledgeGraphService';

const SupabaseDebug = () => {
  const [directQueryResult, setDirectQueryResult] = useState(null);
  const [serviceResult, setServiceResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const testDirectQuery = async () => {
    setLoading(true);
    setError(null);
    try {
      console.log('Testing direct Supabase query...');
      const result = await querySupabase('chi_knowledgegraphmock', {}, {
        limit: 10
      });
      console.log('Direct query result:', result);
      setDirectQueryResult(result);
    } catch (err) {
      console.error('Direct query error:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const testServiceQuery = async () => {
    setLoading(true);
    setError(null);
    try {
      console.log('Testing service getAllSampleTexts...');
      const result = await supabaseKGService.getAllSampleTexts();
      console.log('Service result:', result);
      setServiceResult(result);
    } catch (err) {
      console.error('Service query error:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const testGetById = async (id) => {
    setLoading(true);
    setError(null);
    try {
      console.log(`Testing getMockDataByStoryId('${id}')...`);
      const result = await supabaseKGService.getMockDataByStoryId(id);
      console.log('Get by ID result:', result);
      alert(`Result: ${result ? 'Found data!' : 'No data found'}\nCheck console for details.`);
    } catch (err) {
      console.error('Get by ID error:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-8 space-y-6">
      <h1 className="text-2xl font-bold">Supabase Debug Page</h1>
      
      {loading && <div className="text-blue-600">Loading...</div>}
      {error && <div className="text-red-600 p-4 bg-red-50 rounded">Error: {error}</div>}
      
      <div className="space-y-4">
        <div>
          <button
            onClick={testDirectQuery}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            disabled={loading}
          >
            Test Direct Query (Get All)
          </button>
          {directQueryResult && (
            <div className="mt-2 p-4 bg-gray-100 rounded">
              <pre className="text-xs overflow-auto max-h-96">
                {JSON.stringify(directQueryResult, null, 2)}
              </pre>
            </div>
          )}
        </div>

        <div>
          <button
            onClick={testServiceQuery}
            className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
            disabled={loading}
          >
            Test Service (getAllSampleTexts)
          </button>
          {serviceResult && (
            <div className="mt-2 p-4 bg-gray-100 rounded">
              <p><strong>Sample List:</strong> {serviceResult.sampleList?.length || 0} items</p>
              <p><strong>Sample Texts:</strong> {Object.keys(serviceResult.sampleTexts || {}).length} items</p>
              <pre className="text-xs overflow-auto max-h-96 mt-2">
                {JSON.stringify(serviceResult, null, 2)}
              </pre>
            </div>
          )}
        </div>

        <div className="space-y-2">
          <p className="font-semibold">Test Get By ID:</p>
          <div className="flex gap-2">
            <button
              onClick={() => testGetById('moonAndRabbit')}
              className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
              disabled={loading}
            >
              Get 'moonAndRabbit'
            </button>
            <button
              onClick={() => testGetById('weaving_story')}
              className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
              disabled={loading}
            >
              Get 'weaving_story'
            </button>
            <button
              onClick={() => testGetById('test')}
              className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
              disabled={loading}
            >
              Get 'test'
            </button>
          </div>
        </div>
      </div>

      <div className="mt-8 p-4 bg-yellow-50 rounded">
        <p className="font-semibold mb-2">Instructions:</p>
        <ol className="list-decimal list-inside space-y-1 text-sm">
          <li>Click "Test Direct Query" to fetch all records from chi_knowledgegraphmock table</li>
          <li>Check the console for detailed logs</li>
          <li>If you see data, the Supabase connection is working</li>
          <li>If no data, the table might be empty or the connection is failing</li>
          <li>Try different IDs to see which ones exist in the database</li>
        </ol>
      </div>
    </div>
  );
};

export default SupabaseDebug;

